import { type FunctionComponent } from 'react';
import { IconWrapper } from '../style';
import type { IconProps } from '../types';

export const WarningIcon: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        fill={color ?? 'currentColor'}
        fillRule="evenodd"
        d="M12 2.15c-.96 0-1.85.5-2.35 1.32L1.18 17.61v.02a2.75 2.75 0 0 0 2.34 4.12h16.95a2.75 2.75 0 0 0 2.36-4.13L14.34 3.46A2.75 2.75 0 0 0 12 2.15Zm-1.07 2.1a1.25 1.25 0 0 1 2.14 0l8.46 14.13a1.25 1.25 0 0 1-1.06 1.87H3.53a1.25 1.25 0 0 1-1.06-1.87l8.46-14.13Zm1.07 4c.41 0 .75.34.75.75v4a.75.75 0 0 1-1.5 0V9c0-.41.34-.75.75-.75ZM11.25 17c0-.41.34-.75.75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrapper>
);
